/**
 * Created by Ivan on 15/05/2017.
 */
export default {
    en : {
        inicio : 'Home',
        habitaciones : 'Rooms',
        contacto : 'Contact Us',
        contacto_descripcion : 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit.',
        blog : 'Blog',
        menu : 'Menu',
        spanish : 'Spanish',
        english : 'English',
        book : 'Book Online',
        name : 'Name',
        address : 'Address',
        web : 'Web',
        phone : 'Phone',
        email : 'Email',
        subject : 'Subject',
        message : 'Message',
        location : 'Location',
        enter_name : 'Enter your name',
        enter_lastname : 'Enter your last name',
        enter_email : 'Enter your email address',
        enter_phone : 'Enter your phone number',
        enter_message : 'Write your message',
        enter_subject : 'Subject',
        send_message : 'Send message',
        book_now : 'BOOK A ROOM NOW',
        book__now : 'BOOK NOW',
        advanced_booking_form : 'Advanced Booking Form',
        arrival_date : 'Arrival Date',
        departure_date : 'Departure Date',
        adults : 'Adults',
        children : 'Children',
        title_room_type : 'Select room type',
        room_type : 'Room type',
        our_awesome_services : 'Our Awesome Services',
        our_awesome_services_description : 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit.',
        restaurant : 'Restaurant',
        restaurant_description : 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet.',
        spa_beauty : 'Spa - Beauty & Health',
        spa_beauty_description : 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet.',
        conference : 'Conference Room',
        conference_description : 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet.',
        swimming_pool : 'Swimming Pool',
        swimming_pool_description : 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet.',
        done_contact : 'Your message has ben sended',
        done_contact_message : 'Thanks for comunicate with us',
        get_in_touch : 'GET IN TOUCH',
        useful_links : 'Useful Links',
        our_happy_clients : 'OUR HAPPY CLIENTS',
        our_happy_clients_description : `
            Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit.Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit.
            <br><br>
            Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit.
        `,
        es : 'Spanish',
        en : 'English',
        fr : 'French',
        view_room_list : 'View room list',
        view_details : 'View details',
        night : 'night',
        need_help : 'Need help?',
        need_help_secondary : "If you have any question please don't hesitate to contact us",
        or_use : 'or use',
        contact_form : 'contact form',
        latest_posts : 'Latest post',
        fax : 'fax',
        gallery : 'Gallery',
        grid : 'Grid View',
        block : 'Block View',
        list : 'List View',
        room_services : 'Room services',
        restaurants :  'Restaurants',
        modal_confirm_reservation_title: 'Realizar reservación',
        modal_confirm_reservation_body: 'Está a punto de realizar una reservación, ¿Desea continuar?',
        modal_confirm_reservation_confirmButtonText: 'Si, deseo reservar',
        modal_confirm_reservation_cancelButtonText: 'No, lo haré mas tarde',
        modal_reservation_success_title: 'Reservación realizada',
        modal_reservation_success_body: 'Su reserva ha sido agregada con éxito. En unos minutos se le enviará a su correo la confirmación de la misma.',
        modal_reservation_error_title: 'Error al realizar la reserva',
        modal_reservation_error_body: 'Ocurrió un error al realizar la reserva, por favor inténtelo de nuevo más tarde o póngase en contacto con nosotros.',
        modal_reservation_warning_title: 'Error de validación',
        modal_reservation_warning_body: 'Por favor verifique los campos del formulario',
        modal_reservation_maxcap_exceed_title: 'Capacidad excedida',
        modal_reservation_maxcap_exceed_body: 'Está excediendo la capacidad máxima de personas de la habitación.'
    },
    es : {
        inicio : 'Inicio',
        habitaciones : 'Habitaciones',
        contacto : 'Contacto',
        contacto_descripcion : 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit.',
        blog : 'Blog',
        menu : 'Menú',
        spanish : 'Español',
        english : 'Inglés',
        book : 'Reservar en linea',
        name : 'Nombre',
        address : 'Dirección',
        web : 'Sitio web',
        phone : 'Teléfono',
        email : 'Correo electrónico',
        subject : 'Asunto',
        message : 'Message',
        location : 'Ubicación',
        enter_name : 'Introduzca su nombre',
        enter_lastname : 'Introduzca su apellido',
        enter_email : 'Introduzca su correo electrónico',
        enter_phone : 'Introduzca su número de teléfono',
        enter_message : 'Escriba su mensaje',
        enter_subject : 'Asunto',
        send_message : 'Enviar mensaje',
        book_now : 'RESERVAR HABITACIÓN AHORA',
        book__now : 'RESERVAR AHORA',
        advanced_booking_form : 'Formulario de reservación avanzado',
        arrival_date : 'Fecha de llegada',
        departure_date : 'Fecha de partida',
        adults : 'Adultos',
        children : 'Niños',
        title_room_type : 'Seleccione el tipo de habitación',
        room_type : 'Tipo de habitación',
        our_awesome_services : 'NUESTRAS INSTALACIONES',
        our_awesome_services_description : 'Hotel CEO Group pone a su disposición las diferentes instalaciones con las que contamos en el hotel.',
        restaurant : 'Restaurant',
        restaurant_description : 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet.',
        spa_beauty : 'Spa - Salud & Belleza',
        spa_beauty_description : 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet.',
        conference : 'Salón de conferencias',
        conference_description : 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet.',
        swimming_pool : 'Piscina',
        swimming_pool_description : 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet.',
        done_contact : 'Su mensaje ha sido enviado',
        done_contact_message : 'Gracias por comunicarse con nosotros',
        get_in_touch : 'CONTACTANOS',
        useful_links : 'Enlaces útiles',
        our_happy_clients : 'NUESTROS FELICES CLIENTES',
        our_happy_clients_description : `
            Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit.Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit.
            <br><br>
            Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit.
        `,
        es : 'Español',
        en : 'Inglés',
        fr : 'Frances',
        view_room_list : 'Ver lista de habitaciones',
        view_details : 'Ver detalle',
        night : 'noche',
        need_help : '¿Necesita ayuda?',
        need_help_secondary : "Si tiene alguna pregunta, no dude en contactarnos.",
        or_use : 'o utilice el',
        contact_form : 'formulario de contacto',
        latest_posts : 'Últimos posts',
        fax : 'fax',
        gallery : 'Galería',
        grid : 'Vista de cuadrícula',
        block : 'Vista de bloque',
        list : 'Vista de lista',
        room_services : 'Servicios en la habitación',
        restaurants :  'Restaurantes',
        modal_confirm_reservation_title: 'Realizar reservación',
        modal_confirm_reservation_body: 'Está a punto de realizar una reservación, ¿Desea continuar?',
        modal_confirm_reservation_confirmButtonText: 'Si, deseo reservar',
        modal_confirm_reservation_cancelButtonText: 'No, lo haré mas tarde',
        modal_reservation_success_title: 'Reservación realizada',
        modal_reservation_success_body: 'Su reserva ha sido agregada con éxito. En unos minutos se le enviará a su correo la confirmación de la misma.',
        modal_reservation_error_title: 'Error al realizar la reserva',
        modal_reservation_error_body: 'Ocurrió un error al realizar la reserva, por favor inténtelo de nuevo más tarde o póngase en contacto con nosotros.',
        modal_reservation_warning_title: 'Error de validación',
        modal_reservation_warning_body: 'Por favor verifique los campos del formulario',
        modal_reservation_maxcap_exceed_title: 'Capacidad excedida',
        modal_reservation_maxcap_exceed_body: 'Está excediendo la capacidad máxima de personas de la habitación.'
    },
    fr : {
        inicio : 'Home',
        habitaciones : 'Rooms',
        contacto : 'Contact Us',
        contacto_descripcion : 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit.',
        blog : 'Blog',
        menu : 'Menu',
        spanish : 'Spanish',
        english : 'English',
        book : 'Book Online',
        name : 'Name',
        address : 'Address',
        web : 'Web',
        phone : 'Phone',
        email : 'Email',
        subject : 'Subject',
        message : 'Message',
        location : 'Location',
        enter_name : 'Enter your name',
        enter_lastname : 'Enter your last name',
        enter_email : 'Enter your email address',
        enter_phone : 'Enter your phone number',
        enter_message : 'Write your message',
        enter_subject : 'Subject',
        send_message : 'Send message',
        book_now : 'BOOK A ROOM NOW',
        book__now : 'BOOK NOW',
        advanced_booking_form : 'Advanced Booking Form',
        arrival_date : 'Arrival Date',
        departure_date : 'Departure Date',
        adults : 'Adults',
        children : 'Children',
        title_room_type : 'Select room type',
        room_type : 'Room type',
        our_awesome_services : 'Our Awesome Services',
        our_awesome_services_description : 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit.',
        restaurant : 'Restaurant',
        restaurant_description : 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet.',
        spa_beauty : 'Spa - Beauty & Health',
        spa_beauty_description : 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet.',
        conference : 'Conference Room',
        conference_description : 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet.',
        swimming_pool : 'Swimming Pool',
        swimming_pool_description : 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet.',
        done_contact : 'Your message has ben sended',
        done_contact_message : 'Thanks for comunicate with us',
        get_in_touch : 'GET IN TOUCH',
        useful_links : 'Useful Links',
        our_happy_clients : 'OUR HAPPY CLIENTS',
        our_happy_clients_description : `
            Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit.Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit.
            <br><br>
            Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit.
        `,
        es : 'Spanish',
        en : 'English',
        fr : 'French',
        view_room_list : 'View room list (F)',
        view_details : 'View details(F)',
        night : 'night (f)',
        need_help : 'Need help?',
        need_help_secondary : "If you have any question please don't hesitate to contact us (f)",
        or_use : 'or use',
        contact_form : 'contact form (f)',
        latest_posts : 'Latest post (f)',
        fax : 'fax',
        gallery : 'Gallery(f)',
        grid : 'Grid (f)',
        block : 'Block (f)',
        list : 'List (f)',
        room_services : 'Room services (f)',
        restaurants :  'Restaurants (f)',
        modal_confirm_reservation_title: 'Realizar reservación',
        modal_confirm_reservation_body: 'Está a punto de realizar una reservación, ¿Desea continuar?',
        modal_confirm_reservation_confirmButtonText: 'Si, deseo reservar',
        modal_confirm_reservation_cancelButtonText: 'No, lo haré mas tarde',
        modal_reservation_success_title: 'Reservación realizada',
        modal_reservation_success_body: 'Su reserva ha sido agregada con éxito. En unos minutos se le enviará a su correo la confirmación de la misma.',
        modal_reservation_error_title: 'Error al realizar la reserva',
        modal_reservation_error_body: 'Ocurrió un error al realizar la reserva, por favor inténtelo de nuevo más tarde o póngase en contacto con nosotros.',
        modal_reservation_warning_title: 'Error de validación',
        modal_reservation_warning_body: 'Por favor verifique los campos del formulario',
        modal_reservation_maxcap_exceed_title: 'Capacidad excedida',
        modal_reservation_maxcap_exceed_body: 'Está excediendo la capacidad máxima de personas de la habitación.'
    }
}


// WEBPACK FOOTER //
// ./src/translations.js